import React, { useState } from 'react'
import { MenuItem, Menu, Typography, Box } from '@mui/material'
import {
    Link,
    useMatch,
    useNavigate,
    useResolvedPath,
} from 'react-router-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { auth } from '../../utils/backend/firebase';

const styles = {
    icons: {
        verticalAlign: 'text-bottom'
    }
}

function CustomLink({ children, to, ...props }) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });
  
    return (
        <div>
            <Link
                style={{
                    textDecoration: "none",
                    color: match ? '#F0D201' : '#FFFFFF',
                    fontFamily: 'VarelaRound',
                    fontSize: 20,
                }}
                to={to}
                {...props}
            >
                {children}
            </Link>
        </div>
    );
}

export default function UserMenu() {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const navigate = useNavigate();
    const SignOut = () => {
        if (window.confirm('Log out?') === true) {
            alert("logged out!");
            auth.signOut();
            navigate('/home');
        } else {
            alert('Cancelled!');
        }
    };
    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Typography
                    onClick={handleClick}
                    size="small"
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    sx={{
                        textDecoration: "none",
                        color: '#FFFFFF',
                        fontFamily: 'VarelaRound',
                        fontSize: 18,
                        cursor: 'pointer',
                    }}
                >
                    Profile {open ? <ArrowDropDownIcon sx={styles.icons} /> : <ExpandMoreIcon sx={styles.icons} />}
                </Typography>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        backgroundColor: '#591934',
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 75,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'center', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            >
                <MenuItem>
                    <CustomLink to="/settings" >Profile</CustomLink>
                </MenuItem>
                <MenuItem>
                    <CustomLink to="/view-booking" >View Booking</CustomLink>
                </MenuItem>
                <MenuItem>
                    <Box onClick={SignOut}
                        component='span'
                        sx={{
                            textDecoration: "none",
                            color: '#FFFFFF',
                            fontFamily: 'VarelaRound',
                            fontSize: 20,
                            cursor: 'pointer'
                        }}
                    >Logout</Box>
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}
